<template>
  <div class="light-camera-content" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="pageInfo" label-width="auto" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="5">
            <el-form-item label="摄像头名称">
              <el-input v-model="pageInfo.title" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="摄像头编号">
              <el-input v-model="pageInfo.number" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="摄像头类型">
              <el-select
                placeholder="选择协议类型"
                v-model="pageInfo.camera_type"
                style="width: 100%"
                @change="selectChange"
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="海康萤石云" :value="1"></el-option>
                <el-option label="大华乐橙云" :value="2"></el-option>
                <el-option label="七牛云" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5" class="search-btn-box">
            <el-button type="primary" @click="headSearch"><svg-icon name="search"></svg-icon>搜索</el-button>
            <el-button type="info" @click="headReset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h20"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>添加</el-button
          >
        </div>
      </div>
      <el-table :data="tableData">
        <el-table-column prop="title" label="摄像头名称"></el-table-column>
        <el-table-column prop="number" label="摄像头编号"></el-table-column>
        <el-table-column prop="channel" label="通道号">
          <template slot-scope="scope">
            <span v-if="scope.row.camera_type==1">{{ scope.row.channel }}</span>
            <span v-else> — </span>
          </template>
        </el-table-column>
        <el-table-column prop="camera_type" label="摄像头协议">
          <template slot-scope="scope">
            {{ camera_type_arr[scope.row.camera_type] }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="所属路灯"> </el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>
        <el-table-column label="是否首页显示" prop="type">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.flag"
              :active-value="1"
              :inactive-value="0"
              active-color="#67C23A"
              inactive-color="#aaaaaa"
              @change="changeSwitch(scope.row.id, scope.row.flag)"
            />
          </template>
        </el-table-column>
        <el-table-column label="查看监控">
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              class="item"
              content="查看监控"
              placement="top"
            >
              <div
                class="my-icon-button"
                @click="getOutVideo(scope.row.number, scope.row.channel)"
              >
                <i class="el-icon-video-play"></i>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="edit" label="编辑" width="100">
          <template slot-scope="scope">
            <div class="edit-button">
              <i
                @click="openEditWin(scope.row)"
                class="el-icon-edit pointer mar-r10"
              ></i>
              <i
                class="el-icon-delete pointer"
                @click="delItem(scope.row.id)"
              ></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item label="摄像头名称" prop="title">
            <el-input v-model="editOne.title"></el-input>
          </el-form-item>
          <el-form-item label="摄像头编号" prop="number">
            <el-input v-model="editOne.number"></el-input>
          </el-form-item>
          <el-form-item label="摄像头协议">
            <el-select
              filterable 
              placeholder="请选择摄像头协议"
              v-model="editOne.camera_type"
              style="width: 100%"
            >
              <el-option label="海康萤石云" :value="1"></el-option>
              <el-option label="大华乐橙云" :value="2"></el-option>
              <el-option label="七牛云" :value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="选择路灯">
            <el-select
              clearable
              filterable 
              placeholder="请选择所属路灯"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in lampList"
                :key="t.lamp_id"
                :label="t.name"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">{{ videoData.title }}</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <div class="video-left">
          <video-box
            ref="video_box"
            :video="videoData"
          ></video-box>
        </div>
        <div class="video-right">
          <video-control
            ref="video_control"
            :video="videoData"
          ></video-control>
        </div>
        <div class="clear"></div>
      </div>
    </div>


  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList";
import cameraApi from "@/api/light/camera";
import videoBox from "@/components/video/VideoBox";
import videoControl from "@/components/video/VideoControl";
export default {
  components: {
    videoBox,
    videoControl
  },
  data() {
    return {
      loading: false,
      camera_type_arr: ['', '海康萤石云', '大华乐橙云', '七牛云'],
      tableData: [],
      pageInfo: {
        camera_type: '',
        title: '',
        number: '',
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      videoData: {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      },
      accessToken: null,
      dialogVisible: false,
      editType: -1,
      lampList: [],
      editOne: {
        number: '',
        title: '',
        address: '',
        camera_type: '',
        lamp_id: null
      }
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.pageInfo.page = pageIndex;
      this.loading = true;
      cameraApi.cameraList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.getLampList()
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 10
      this.getTableData(1)
    },
    headReset() {
      this.pageInfo = {
        camera_type: '',
        title: '',
        number: '',
        page: 1,
        pageSize: 10,
      }
      this.getTableData(1)
    },
    selectChange(value) {
      this.getTableData(this.pageInfo.page);
    },
    async getOutVideo(number,channel) {
      await cameraApi.cameraInfo({
        number: number,
        channel: channel
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoData = {
            id: res.data.data.id,
            title: res.data.data.title,
            number: res.data.data.number,
            camera_type: res.data.data.camera_type,
            channel: res.data.data.channel,
            access_token: res.data.data.access_token,
            dialogVisible: true
          }
        }
      });
    },
    closeVideo() {
      // 关闭视频
      this.videoData = {
        id: null,
        title: '',
        number: '',
        camera_type: 1,
        channel: 1,
        access_token: '',
        dialogVisible: false
      }
    },
    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          number: '',
          title: '',
          address: '',
          camera_type: '',
          lamp_id: null
        };
        this.editType = "create";
      } else {
        this.editOne = {
          id: index.id,
          title: index.title,
          number: index.number,
          address: index.address,
          camera_type: index.camera_type,
          lamp_id: index.lamp_id
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      cameraApi.cameraEdit(this.editOne.id, this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("修改成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    createItem() {
      cameraApi.cameraAdd(this.editOne).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("添加成功");
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getLampList() { // 获取路灯列表
      lightListApi.lightList({
        page: 1,
        pageSize: 500,
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.lampList = resData.list;
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cameraApi.cameraDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeSwitch(id, value) {
      cameraApi.cameraSetHome(id,{ flag: value }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success("设置成功");
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    }

  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>

<style lang='less'>
.light-camera-content{
  .video-left{
    width:600px;
    height:400px;
    float: left;
  }
  .video-right{
    float: right;
  }

  .form-info{
    .el-form-item__label{
      width:90px;
    }
  }
} 

</style>
      